import {Injectable} from '@angular/core';
import 'rxjs/add/operator/map';
import {HttpService} from './http.service';
import {UtilService} from './util.service';

@Injectable()
export class HcaHistoryChangesService {
  constructor(private http: HttpService, private utilService: UtilService) {
  }

  searchLogs(body) {
    return this.http.post(`/audit/search`, body)
      .map(res => res.json())
      .catch(this.utilService.handleError);
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/_services/hca-history-changes.service.ts